// extracted by mini-css-extract-plugin
export default {"slide":"RDDyG","card":"ZoPoI","innerSize--full":"kRLW5","slide-active":"EX08t"};